import { filtersHelper } from '@/utils';
import { stateModel } from '@/models/api/state.model';
import { locationModel } from '@/models/api/location.model';

export const countryModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    code: data.code,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    states: (data.states ?? []).map((item) => stateModel({ data: item })),
    locations: (data.locations ?? []).map((item) => locationModel({ data: item })),
});